import { UNIDADES } from "@caint/data";
import type { Unidade } from "@caint/shared";

/** Filtra o cadastro (104 unidades) por tipo e por texto (nome ou município). */
export function filtrarUnidades(tipo: string, busca: string): readonly Unidade[] {
  const q = busca.trim().toLowerCase();
  return UNIDADES.filter(
    (u) =>
      (!tipo || u.tipo === tipo) &&
      (!q || u.nome.toLowerCase().includes(q) || u.municipio.toLowerCase().includes(q)),
  );
}
